export const LOGIN         = 'LOGIN'
export const LOGOUT        = 'LOGOUT'
export const SET_USER      = 'SET_USER'
export const SET_USER_TYPE = 'SET_USER_TYPE'